import styled from 'styled-components';

export const BreedersSearchContent = styled.section`
  display: flex;
  flex: 1 0;
  justify-content: flex-end;

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .search-by {
    width: 10rem;
  }
  .search-value {
    width: 15rem;
  }
`;
